import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import App from './customScripts/App';
import reportWebVitals from './predefinedScripts/reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
